import { NumberInput, Stack } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectAutoPipeRoutingPipeElevationsMmAboveFloorBySystem,
  selectSelectedAutoPipeRoutingSystemType,
  setAutoPipeRoutingPipeElevationsMmAboveFloorForSystemInRedux,
} from "../../pipeRoutingSlice";

const MIN_PIPE_ELEVATION_MM_ABOVE_FLOOR = 100;
const MAX_PIPE_ELEVATION_MM_ABOVE_FLOOR = 8000;

export const AutoPipeRoutingPipeElevationsStep = () => {
  const dispatch = useAppDispatch();
  const selectedSystemType = useAppSelector(selectSelectedAutoPipeRoutingSystemType);
  const pipeElevationsMmAboveFloorBySystem = useAppSelector(
    selectAutoPipeRoutingPipeElevationsMmAboveFloorBySystem
  );

  const selectedPipeElevations = selectedSystemType
    ? pipeElevationsMmAboveFloorBySystem[selectedSystemType]
    : undefined;

  const xDirectionMmAboveFloor = selectedPipeElevations?.xDirectionMmAboveFloor ?? 0;
  const yDirectionMmAboveFloor = selectedPipeElevations?.yDirectionMmAboveFloor ?? 0;

  const hasValidXDirectionMmAboveFloor =
    xDirectionMmAboveFloor >= MIN_PIPE_ELEVATION_MM_ABOVE_FLOOR &&
    xDirectionMmAboveFloor <= MAX_PIPE_ELEVATION_MM_ABOVE_FLOOR;
  const hasValidYDirectionMmAboveFloor =
    yDirectionMmAboveFloor >= MIN_PIPE_ELEVATION_MM_ABOVE_FLOOR &&
    yDirectionMmAboveFloor <= MAX_PIPE_ELEVATION_MM_ABOVE_FLOOR;

  return (
    <Stack gap="sm">
      <NumberInput
        label="Rorhoyde i X-retning (mm over gulv)"
        value={xDirectionMmAboveFloor}
        onChange={(value) => {
          if (!selectedSystemType || typeof value !== "number") {
            return;
          }

          dispatch(
            setAutoPipeRoutingPipeElevationsMmAboveFloorForSystemInRedux({
              systemType: selectedSystemType,
              pipeElevationsMmAboveFloor: {
                xDirectionMmAboveFloor: value,
                yDirectionMmAboveFloor,
              },
            })
          );
        }}
        min={MIN_PIPE_ELEVATION_MM_ABOVE_FLOOR}
        max={MAX_PIPE_ELEVATION_MM_ABOVE_FLOOR}
        thousandSeparator=" "
        error={
          !hasValidXDirectionMmAboveFloor
            ? `Må være mellom ${MIN_PIPE_ELEVATION_MM_ABOVE_FLOOR} og ${MAX_PIPE_ELEVATION_MM_ABOVE_FLOOR} mm`
            : undefined
        }
      />
      <NumberInput
        label="Rorhoyde i Y-retning (mm over gulv)"
        value={yDirectionMmAboveFloor}
        onChange={(value) => {
          if (!selectedSystemType || typeof value !== "number") {
            return;
          }

          dispatch(
            setAutoPipeRoutingPipeElevationsMmAboveFloorForSystemInRedux({
              systemType: selectedSystemType,
              pipeElevationsMmAboveFloor: {
                xDirectionMmAboveFloor,
                yDirectionMmAboveFloor: value,
              },
            })
          );
        }}
        min={MIN_PIPE_ELEVATION_MM_ABOVE_FLOOR}
        max={MAX_PIPE_ELEVATION_MM_ABOVE_FLOOR}
        thousandSeparator=" "
        error={
          !hasValidYDirectionMmAboveFloor
            ? `Må være mellom ${MIN_PIPE_ELEVATION_MM_ABOVE_FLOOR} og ${MAX_PIPE_ELEVATION_MM_ABOVE_FLOOR} mm`
            : undefined
        }
      />
    </Stack>
  );
};
